import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=396d5a7b"
import script from "./NewsBlock.vue?vue&type=script&lang=js"
export * from "./NewsBlock.vue?vue&type=script&lang=js"
import style0 from "./NewsBlock.vue?vue&type=style&index=0&id=396d5a7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports